/* WellKept cart: PO number + Returns-agreement gate for Check out (cart page and cart drawer).
   Loaded from layout/theme.liquid on every page (2026-10-30 hotfix). It used to be inline in snippets/cart-summary.liquid,
   but the cart drawer only renders that snippet when the cart has items; after an add-to-cart Horizon morphs the drawer in,
   and inline scripts inserted by morph never execute, so the drawer's Check out stayed disabled even when ticked.
   All listeners are delegated on document and the state is re-evaluated after every cart render. */
  (function () {
    if (window.wkPoInit) return; window.wkPoInit = true;
    var timer = null;
    function save(value) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'PO Number': value } })
      }).catch(function () {});
    }
    function handle(e) {
      if (!e.target.matches || !e.target.matches('[data-wk-po]')) return;
      var value = e.target.value.slice(0, 40);
      document.querySelectorAll('[data-wk-po]').forEach(function (el) { if (el !== e.target) el.value = value; });
      clearTimeout(timer);
      if (e.type === 'change') { save(value); } else { timer = setTimeout(function () { save(value); }, 600); }
    }
    document.addEventListener('input', handle);
    document.addEventListener('change', handle);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-wk-po]')) { e.preventDefault(); clearTimeout(timer); save(e.target.value.slice(0, 40)); }
    });
  })();
  (function () {
    if (window.wkAgreeInit) return; window.wkAgreeInit = true;
    var MSG_AGREE = 'Please tick the Returns Policy box above to check out.';
    var MSG_QUOTE = 'Your cart includes an item that is priced by quote. Remove it to check out, or request a quote.';
    function set(el, prop, val) { if (el[prop] !== val) el[prop] = val; }
    function setAttr(el, name, val) { if (el.getAttribute(name) !== val) el.setAttribute(name, val); }
    function sync() {
      document.querySelectorAll('[data-wk-ctas]').forEach(function (box) {
        var cb = box.querySelector('[data-wk-agree]');
        var btn = box.querySelector('[data-wk-checkout]');
        var hint = box.querySelector('[data-wk-agree-hint]');
        var nudge = box.querySelector('[data-wk-nudge]');
        if (!btn) return;
        var quote = box.hasAttribute('data-wk-quote-block');
        var ok = !!(cb && cb.checked) && !quote;
        set(btn, 'disabled', !ok);
        setAttr(btn, 'aria-disabled', ok ? 'false' : 'true');
        if (hint) set(hint, 'hidden', ok || quote);
        if (nudge && ok) set(nudge, 'hidden', true);
      });
    }
    var queued = false;
    function queue() {
      if (queued) return; queued = true;
      (window.queueMicrotask || setTimeout)(function () { queued = false; sync(); });
    }
    function nudge(box) {
      var n = box.querySelector('[data-wk-nudge]');
      var cb = box.querySelector('[data-wk-agree]');
      var quote = box.hasAttribute('data-wk-quote-block');
      if (n) { n.textContent = quote ? MSG_QUOTE : MSG_AGREE; n.hidden = false; }
      if (!quote && cb) {
        var row = cb.closest('.wk-agree');
        if (row) { row.classList.remove('wk-agree--flag'); void row.offsetWidth; row.classList.add('wk-agree--flag'); }
        cb.focus({ preventScroll: false });
      }
    }
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-wk-agree]')) return;
      // Keep every copy (cart page / drawer) in step: they all belong to form="cart-form" and are required.
      document.querySelectorAll('[data-wk-agree]').forEach(function (el) { if (el !== e.target) el.checked = e.target.checked; });
      sync();
    });
    document.addEventListener('click', function (e) {
      var wrap = e.target.closest && e.target.closest('[data-wk-checkout-wrap], [data-wk-checkout]');
      if (!wrap) return;
      var box = wrap.closest('[data-wk-ctas]');
      if (!box) return;
      var cb = box.querySelector('[data-wk-agree]');
      if (box.hasAttribute('data-wk-quote-block') || !cb || !cb.checked) {
        e.preventDefault(); e.stopPropagation();
        nudge(box);
      }
    }, true);
    // Re-run after any cart refresh: Horizon morphs the cart section, which re-adds the server's disabled attribute
    // to the button (an attribute change, not a child-list change), so watch those attributes too.
    new MutationObserver(queue).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['disabled', 'data-wk-quote-block', 'hidden']
    });
    ['cart:update', 'cart:refresh', 'shopify:section:load', 'pageshow'].forEach(function (t) { (t === 'pageshow' ? window : document).addEventListener(t, queue); });
    document.addEventListener('DOMContentLoaded', sync);
    sync();
  })();
